export default "__VITE_ASSET__ca418640__"